import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  withCredentials: true, // send httpOnly auth cookies with every request (XSS defense)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available (backward compat during migration;
// primary auth is now the httpOnly cookie set by backend on login)
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Products API
export const productsApi = {
  getAll: async (params = {}) => {
    const response = await apiClient.get('/products', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await apiClient.get(`/products/${id}`);
    return response.data;
  },
  
  getFeatured: async () => {
    const response = await apiClient.get('/products/featured');
    return response.data;
  },
  
  getBestsellers: async () => {
    const response = await apiClient.get('/products/bestsellers');
    return response.data;
  },
  
  getNew: async () => {
    const response = await apiClient.get('/products/new');
    return response.data;
  },
  
  getWeeklyDeal: async () => {
    const response = await apiClient.get('/products/weekly-deal');
    return response.data;
  },
  
  search: async (query) => {
    const response = await apiClient.get('/search', { params: { q: query } });
    return response.data;
  },
  
  create: async (product) => {
    const response = await apiClient.post('/products', product);
    return response.data;
  },
  
  update: async (id, product) => {
    const response = await apiClient.put(`/products/${id}`, product);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await apiClient.delete(`/products/${id}`);
    return response.data;
  },
};

// Categories API
export const categoriesApi = {
  getAll: async () => {
    const response = await apiClient.get('/categories');
    return response.data;
  },
};

// Orders API
export const ordersApi = {
  create: async (order) => {
    const response = await apiClient.post('/orders', order);
    return response.data;
  },
  
  getAll: async () => {
    const response = await apiClient.get('/orders');
    return response.data;
  },
  
  getById: async (orderId) => {
    const response = await apiClient.get(`/orders/${orderId}`);
    return response.data;
  },
  
  updateStatus: async (orderId, status) => {
    const response = await apiClient.put(`/orders/${orderId}/status`, { status });
    return response.data;
  },
};

// Admin API
export const adminApi = {
  login: async (credentials) => {
    const response = await apiClient.post('/admin/login', credentials);
    return response.data;
  },
  
  verify: async () => {
    const response = await apiClient.get('/admin/verify');
    return response.data;
  },
  
  getStats: async () => {
    const response = await apiClient.get('/admin/stats');
    return response.data;
  },
};

export default apiClient;
